// import React, { useEffect, useState, useMemo } from "react";
// import SpecialTripsAPI from "../api/SpecialTripsAPI";
// import TripCard from "../components/TripCard";
// import NotFound from "../assets/media/page_not-found.jpg";

// // Helper function for grouping and sorting
// const processTripsData = (trips) => {
//   if (!trips || !Array.isArray(trips)) {
//     return [];
//   }

//   // 1. Sort trips by batchDate (Ascending: closest upcoming date first)
//   // **NOTE**: Replace 'batchDate' with your actual date field name if different.
//   const sortedTrips = [...trips].sort((a, b) => {
//     const dateA = new Date(a.batchDate);
//     const dateB = new Date(b.batchDate); 
//     return dateA - dateB;
//   });

//   // 2. Group sorted trips by location
//   const groupedTrips = sortedTrips.reduce((acc, trip) => {
//     const location = trip.location;
//     if (location) {
//       if (!acc[location]) {
//         acc[location] = [];
//       }
//       acc[location].push(trip);
//     }
//     return acc;
//   }, {});

//   // 3. Convert the grouped object into an array of objects
//   //    for easier mapping in the render function:
//   //    [{ location: 'State A', trips: [...] }, { location: 'State B', trips: [...] }, ...]
//   const groupedTripsArray = Object.keys(groupedTrips).map((location) => ({
//     location: location,
//     trips: groupedTrips[location],
//   }));

//   return groupedTripsArray;
// };

// const SpecialTripsDropDown = () => {
//   const [specialTripsDetails, setSpecialTripsDetails] = useState([]);
//   const [error, setError] = useState(null);
//   const [loading, setLoading] = useState(true);

//   // Fetch Special trips data
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const res = await SpecialTripsAPI.getSpecialTrips();

//         if (res?.data && Array.isArray(res.data)) {
//           setSpecialTripsDetails(res.data);
//         } else {
//           setSpecialTripsDetails([]);
//         }
//         setLoading(false);
//       } catch (err) {
//         console.error("Error fetching special trips:", err);
//         setError("Unable to load trip data.");
//         setLoading(false);
//       }
//     };
//     fetchData();
//   }, []);

//   // Use useMemo to re-process the data only when specialTripsDetails changes
//   const groupedAndSortedTrips = useMemo(() => {
//     return processTripsData(specialTripsDetails);
//   }, [specialTripsDetails]);

//   return (
//     <section className="custom-special-trips-section my-3" id="upcomingTrips">
//       <div className="container-fluid">
//         <div className="row px-0 px-lg-5">
//           <div className="col-lg-12">
//             <div className="accordion" id="specialTripsAccordion">
//               {/* ... Accordion Header (Special Trips Button) ... */}
//               <div
//                 className="accordion-item d-flex flex-column align-items-center px-1"
//                 style={{ border: "none" }}
//               >
//                 <h1
//                   className="accordion-header custom-special-trips-header d-flex justify-content-center align-items-center"
//                   id="specialTripsHeading"
//                 >
//                   <button
//                     className="accordion-button fs-3 fw-bold custom-special-trips-accordion-button text-center py-2 pb-3 d-block"
//                     type="button"
//                     data-bs-toggle="collapse"
//                     data-bs-target="#specialTripsDropdownCollapse"
//                     aria-expanded="true"
//                     aria-controls="specialTripsDropdownCollapse"
//                     style={{ color: "#249acd" }}
//                   >
//                     Special Trips
//                   </button>
//                 </h1>
//                 <div
//                   id="specialTripsDropdownCollapse"
//                   className="accordion-collapse w-100 collapse show custom-special-trips-body"
//                   aria-labelledby="specialTripsDropdownHeading"
//                   data-bs-parent="#specialTripsDropdownAccordion"
//                 >
//                   <div className="accordion-body">
//                     {/* Loading State */}
//                     {loading ? (
//                       <div className="text-center py-5">
//                         <div
//                           className="spinner-border text-primary"
//                           role="status"
//                         >
//                           <span className="visually-hidden">Loading...</span>
//                         </div>
//                         <p className="mt-3">Loading special trips...</p>
//                       </div>
//                     ) : error ? (
//                       /* Error State */
//                       <div className="text-center py-5">
//                         <h5 className="text-danger">{error}</h5>
//                         <p className="text-muted">Please try again later</p>
//                       </div>
//                     ) : groupedAndSortedTrips.length > 0 ? (
//                       /* Data Found - Iterate over Grouped and Sorted Data */
//                       <div className="row">
//                         <div className="col-12 col-md-12 col-lg-12 custom-upcoming-trips-card-container px-0 px-md-1 px-lg-3">
//                           {groupedAndSortedTrips.map((group) => (
//                             <div
//                               key={group.location} // Use location as the key for the group
//                               className="mb-2 mb-md-3 mb-lg-5 px-lg-0 px-xl-3"
//                             >
//                               <h4
//                                 className="my-2 w-100 custom-font-size"
//                                 style={{
//                                   color: "#249acd",
//                                   padding: "0 0 7px",
//                                   borderBottom: "4px solid #f36d21",
//                                   textTransform: "capitalize",
//                                 }}
//                               >
//                                 {group.location} {/* Display the Location/State */}
//                               </h4>
//                               <div className="row custom-upcoming-trips-card-cont d-flex justify-content-center justify-content-md-start justify-content-lg-start">
//                                 {group.trips.map((trip) => (
//                                   // Iterate over the sorted trips within the group
//                                   <TripCard
//                                     key={trip?.id || Math.random()} // Use unique trip ID for the card key
//                                     className="w-100"
//                                     trip={trip}
//                                     showLocationInCard={false}
//                                   />
//                                 ))}
//                               </div>
//                             </div>
//                           ))}
//                         </div>
//                       </div>
//                     ) : (
//                       /* No Data - Show Fallback Image */
//                       <div className="text-center py-5">
//                         <img
//                           src={NotFound}
//                           alt="No Trips Available"
//                           style={{ maxWidth: "400px", width: "100%" }}
//                         />
//                         <h4 className="mt-3">
//                           No Special Trips available at the moment.
//                         </h4>
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default SpecialTripsDropDown;



// import React, { useEffect, useState, useMemo } from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Navigation, Pagination } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/navigation";
// import "swiper/css/pagination";
// import SpecialTripsAPI from "../api/SpecialTripsAPI";
// import TripCard from "../components/TripCard";
// import NotFound from "../assets/media/page_not-found.jpg";

// // Helper function for grouping and sorting
// const processTripsData = (trips) => {
//   if (!trips || !Array.isArray(trips)) {
//     return [];
//   }

//   // 1. Sort trips by batchDate (Ascending: closest upcoming date first)
//   const sortedTrips = [...trips].sort((a, b) => {
//     const dateA = new Date(a.batchDate);
//     const dateB = new Date(b.batchDate);
//     return dateA - dateB;
//   });

//   // 2. Group sorted trips by location
//   const groupedTrips = sortedTrips.reduce((acc, trip) => {
//     const location = trip.location;
//     if (location) {
//       if (!acc[location]) {
//         acc[location] = [];
//       }
//       acc[location].push(trip);
//     }
//     return acc;
//   }, {});

//   // 3. Convert the grouped object into an array of objects
//   const groupedTripsArray = Object.keys(groupedTrips).map((location) => ({
//     location: location,
//     trips: groupedTrips[location],
//   }));

//   return groupedTripsArray;
// };

// const SpecialTripsDropDown = () => {
//   const [specialTripsDetails, setSpecialTripsDetails] = useState([]);
//   const [error, setError] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [isOpen, setIsOpen] = useState(true);

//   // Fetch Special trips data
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const res = await SpecialTripsAPI.getSpecialTrips();

//         if (res?.data && Array.isArray(res.data)) {
//           setSpecialTripsDetails(res.data);
//         } else {
//           setSpecialTripsDetails([]);
//         }
//         setLoading(false);
//       } catch (err) {
//         console.error("Error fetching special trips:", err);
//         setError("Unable to load trip data.");
//         setLoading(false);
//       }
//     };
//     fetchData();
//   }, []);

//   // Use useMemo to re-process the data only when specialTripsDetails changes
//   const groupedAndSortedTrips = useMemo(() => {
//     return processTripsData(specialTripsDetails);
//   }, [specialTripsDetails]);

//   return (
//     <section className="custom-special-trips-section my-3" id="specialTrips">
//       <div className="container-fluid">
//         <div className="row d-flex flex-column align-items-center">
//           <div className="col-lg-11 d-flex flex-column align-items-center">
//             <div
//               className="fs-3 w-100 fw-bold text-center py-3 cursor-pointer"
//               style={{
//                 color: "#249acd",
//                 borderBottom: "4px solid #249acd",
//                 cursor: "pointer",
//               }}
//               onClick={() => setIsOpen(!isOpen)}
//             >
//               Special Trips
//             </div>

//             {isOpen && (
//               <>
//                 {/* Loading State */}
//                 {loading ? (
//                   <div className="text-center py-5">
//                     <div className="spinner-border text-primary" role="status">
//                       <span className="visually-hidden">Loading...</span>
//                     </div>
//                     <p className="mt-3">Loading special trips...</p>
//                   </div>
//                 ) : error ? (
//                   /* Error State */
//                   <div className="text-center py-5">
//                     <h5 className="text-danger">{error}</h5>
//                     <p className="text-muted">Please try again later</p>
//                   </div>
//                 ) : groupedAndSortedTrips.length > 0 ? (
//                   /* Data Found - Display with Swiper */
//                   <div className="row w-100 mt-4">
//                     <div className="col-12 px-0">
//                       {groupedAndSortedTrips.map((group, index) => (
//                         <div key={`location-${index}`}>
//                           <h4
//                             className="my-2 w-100 custom-font-size"
//                             style={{
//                               color: "#249acd",
//                               padding: "0 0 7px",
//                               borderBottom: "4px solid #f36d21",
//                               textTransform: "capitalize",
//                             }}
//                           >
//                             {group.location} ({group.trips.length} trips)
//                           </h4>

//                           <Swiper
//                             modules={[Navigation, Pagination]}
//                             spaceBetween={20}
//                             slidesPerView={1}
//                             navigation
//                             pagination={{ clickable: true }}
//                             breakpoints={{
//                               640: { slidesPerView: 2, spaceBetween: 20 },
//                               768: { slidesPerView: 3, spaceBetween: 20 },
//                               1024: { slidesPerView: 3, spaceBetween: 25 },
//                               1440: { slidesPerView: 4, spaceBetween: 25 },
//                             }}
//                             className="my-3 custom-aligned-swiper"
//                           >
//                             {group.trips.map((trip, tripIndex) => (
//                               <SwiperSlide
//                                 key={`${group.location}-${trip.id}-${tripIndex}`}
//                               >
//                                 <TripCard
//                                   className="w-100"
//                                   trip={trip}
//                                   showLocationInCard={false}
//                                 />
//                               </SwiperSlide>
//                             ))}
//                           </Swiper>
//                         </div>
//                       ))}
//                     </div>
//                   </div>
//                 ) : (
//                   /* No Data - Show Fallback Image */
//                   <div className="text-center py-5">
//                     <img
//                       src={NotFound}
//                       alt="No Trips Available"
//                       style={{ maxWidth: "400px", width: "100%" }}
//                     />
//                     <h4 className="mt-3">
//                       No Special Trips available at the moment.
//                     </h4>
//                   </div>
//                 )}
//               </>
//             )}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default SpecialTripsDropDown;



import React, { useEffect, useState, useMemo } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import SpecialTripsAPI from "../api/SpecialTripsAPI";
import TripCard from "../components/TripCard";
import NotFound from "../assets/media/page_not-found.jpg";

// Helper function for grouping and sorting
const processTripsData = (trips) => {
  if (!trips || !Array.isArray(trips)) {
    return [];
  }

  const sortedTrips = [...trips].sort((a, b) => {
    const dateA = new Date(a.batchDate);
    const dateB = new Date(b.batchDate);
    return dateA - dateB;
  });

  const groupedTrips = sortedTrips.reduce((acc, trip) => {
    const location = trip.location;
    if (location) {
      if (!acc[location]) {
        acc[location] = [];
      }
      acc[location].push(trip);
    }
    return acc;
  }, {});

  const groupedTripsArray = Object.keys(groupedTrips).map((location) => ({
    location: location,
    trips: groupedTrips[location],
  }));

  return groupedTripsArray;
};

const SpecialTripsDropDown = () => {
  const [specialTripsDetails, setSpecialTripsDetails] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isOpen, setIsOpen] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await SpecialTripsAPI.getSpecialTrips();
        if (res?.data && Array.isArray(res.data)) {
          setSpecialTripsDetails(res.data);
        } else {
          setSpecialTripsDetails([]);
        }
        setLoading(false);
      } catch (err) {
        console.error("Error fetching special trips:", err);
        setError("Unable to load trip data.");
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const groupedAndSortedTrips = useMemo(() => {
    return processTripsData(specialTripsDetails);
  }, [specialTripsDetails]);

  return (
    <section className="custom-special-trips-section my-3" id="specialTrips">
      <div className="container-fluid">
        <div className="row d-flex flex-column align-items-center">
          <div className="col-lg-11 d-flex flex-column align-items-center">
            <div
              className="fs-3 w-100 fw-bold text-center py-3 cursor-pointer"
              style={{
                color: "#249acd",
                borderBottom: "4px solid #249acd",
                cursor: "pointer",
              }}
              onClick={() => setIsOpen(!isOpen)}
            >
              Special Trips
            </div>

            {isOpen && (
              <>
                {loading ? (
                  <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-3">Loading special trips...</p>
                  </div>
                ) : error ? (
                  <div className="text-center py-5">
                    <h5 className="text-danger">{error}</h5>
                    <p className="text-muted">Please try again later</p>
                  </div>
                ) : groupedAndSortedTrips.length > 0 ? (
                  <div className="row w-100 mt-4">
                    <div className="col-12 px-0">
                      {groupedAndSortedTrips.map((group, index) => (
                        <div key={`location-${index}`}>
                          <h4
                            className="my-2 w-100 custom-font-size"
                            style={{
                              color: "#249acd",
                              padding: "0 0 7px",
                              borderBottom: "4px solid #f36d21",
                              textTransform: "capitalize",
                            }}
                          >
                            {group.location} ({group.trips.length} trips)
                          </h4>

                          <Swiper
                            modules={[Navigation, Pagination]}
                            spaceBetween={20}
                            slidesPerView={1}
                            navigation
                            pagination={{ clickable: true }}
                            breakpoints={{
                              640: { slidesPerView: 2, spaceBetween: 15 },
                              768: { slidesPerView: 3, spaceBetween: 15 },
                              1024: { slidesPerView: 3, spaceBetween: 18 },
                              1440: { slidesPerView: 4, spaceBetween: 20 },
                            }}
                            className="my-3 custom-aligned-swiper"
                          >
                            {group.trips.map((trip, tripIndex) => (
                              <SwiperSlide
                                key={`${group.location}-${trip.id}-${tripIndex}`}
                              >
                                <TripCard
                                  className="w-100"
                                  trip={trip}
                                  showLocationInCard={false}
                                />
                              </SwiperSlide>
                            ))}
                          </Swiper>
                        </div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <div className="text-center py-5">
                    <img
                      src={NotFound}
                      alt="No Trips Available"
                      style={{ maxWidth: "400px", width: "100%" }}
                    />
                    <h4 className="mt-3">
                      No Special Trips available at the moment.
                    </h4>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SpecialTripsDropDown;